import { Currency, SupportedChainId } from 'maia-core-sdk'

import { BaseVirtualizedToken } from '../baseVirtualizedToken'
import { GlobalToken } from '../globalToken'

/**
 * These tokens reside on the branch chains of the ulysses system,
 * and represent a deposit of the global token on the branch chain.
 *
 * @export
 * @class LocalToken
 * @extends {BaseVirtualizedToken}
 */
export class LocalToken extends BaseVirtualizedToken {
  public readonly isGlobal: false = false as const

  /**
   * The global token that this local token represents.
   *
   * @type {GlobalToken}
   * @memberof LocalToken
   */
  public readonly globalToken: GlobalToken

  public constructor(
    chainId: number,
    address: string,
    decimals: number,
    underlyingCurrency: Currency,
    globalToken: GlobalToken,
    symbol?: string,
    name?: string
  ) {
    super(address, chainId, decimals, underlyingCurrency, symbol, name)
    this.globalToken = globalToken
  }

  /**
   * Gets the token address of the hToken for a given chain.
   * @param chainId chainId to get the hToken balance from
   * @returns
   */
  public getChainTokenAddress(chainId: SupportedChainId) {
    return this.globalToken.hTokensPerChain?.get(chainId)
  }
}
